<p-toggleswitch 
  [(ngModel)]="_value" 
  [trueValue]="trueValue || true"
  [falseValue]="falseValue || false"
  (ngModelChange)="_onValueChange($event)"
/>